export const socialLinks = [
  {
    label: "GitHub",
    href: "https://github.com/veryobinna",
    shortLabel: "Profile",
    icon: "github",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/obinnaokwuolisa/",
    shortLabel: "Profile",
    icon: "linkedin",
  },
  {
    label: "Email",
    href: "mailto:kingobiorah@gmail.com",
    shortLabel: "Open mail app",
    icon: "mail",
  },
  {
    label: "Medium",
    href: "https://medium.com/@obinnaprime",
    shortLabel: "Profile",
    icon: "medium",
  },
];

export const experiences = [
  {
    company: "Informanos",
    role: "Senior Software Engineer (AI & Cloud)",
    period: "2025 - Present",
  },
  {
    company: "Intransigense",
    role: "Lead Software Engineer",
    period: "2024 - 2025",
  },
  {
    company: "Blick Arts Materials",
    role: "Software Engineer",
    period: "2018 - 2024",
  },
  {
    company: "Andela",
    role: "Software Engineer",
    period: "2017 - 2018",
  },
];

export const featuredProjects = [
  {
    name: "PromptOps",
    summary:
      "AI-assisted DevOps platform that converts natural-language deployment prompts into cloud-ready infrastructure, CI/CD workflows, and deployment plans.",
    detail:
      "Focused on orchestration, validation, infrastructure generation, and deployment planning for cloud delivery workflows.",
    href: "https://github.com/veryobinna/promptops",
    meta: "GitHub project",
    accent: "PO",
  },
  {
    name: "CrackMyIELTS",
    summary:
      "AI-assisted IELTS preparation project designed to help candidates practice and prepare more effectively.",
    detail:
      "Public GitHub project focused on applying AI to exam preparation workflows for IELTS learners.",
    href: "https://github.com/veryobinna/crackmyielts/",
    meta: "GitHub project",
    accent: "CI",
  },
  {
    name: "AI Desktop RAG App",
    summary:
      "Desktop application for chatting with local documents using ingestion, embeddings, retrieval, and LLM-backed response generation.",
    detail:
      "Built for local-first performance and practical retrieval workflows instead of demo-only RAG interactions.",
    href: null,
    meta: "Private case study",
    accent: "AR",
  },
];

export const projectArchive = [
  ...featuredProjects,
  {
    name: "News Feed App",
    summary: "News aggregation app curating updates from multiple sources.",
    detail: "Public GitHub project focused on feed composition and presentation.",
    href: "https://github.com/veryobinna/news-feed-app",
    meta: "GitHub",
    accent: "NF",
  },
  {
    name: "Document Manager",
    summary: "Lightweight note-taking and document management application.",
    detail: "Public project centered on productivity workflows and simple UX.",
    href: "https://github.com/veryobinna/doc-mgt",
    meta: "GitHub",
    accent: "DM",
  },
  {
    name: "News Sentiment Analysis",
    summary: "Real-time sentiment analysis pipeline for news coverage.",
    detail: "Explores data processing and classification against live content streams.",
    href: "https://github.com/veryobinna/NewsSentimentAnalysis",
    meta: "GitHub",
    accent: "NS",
  },
  {
    name: "Water and Air Pollution Analysis",
    summary: "Case-study analysis of contaminants across water and air datasets.",
    detail: "Data-oriented project examining environmental signals for selected regions.",
    href: "https://github.com/veryobinna/case-studies-project",
    meta: "GitHub",
    accent: "WA",
  },
];

export const skillGroups = [
  {
    title: "AI & Product Systems",
    items: [
      "OpenAI APIs",
      "RAG pipelines",
      "AI agents",
      "LLM workflows",
      "Conversational interfaces",
      "Voice integrations",
    ],
  },
  {
    title: "Backend & Frontend",
    items: [
      "Python",
      "FastAPI",
      "Node.js",
      "React",
      "TypeScript",
      "REST APIs",
    ],
  },
  {
    title: "Cloud & Platform",
    items: [
      "AWS ECS",
      "Fargate",
      "RDS",
      "S3",
      "Terraform",
      "CI/CD",
      "Docker",
    ],
  },
  {
    title: "Data & Reliability",
    items: [
      "PostgreSQL",
      "MongoDB",
      "DynamoDB",
      "Kafka",
      "OpenTelemetry",
      "Prometheus",
      "CloudWatch",
    ],
  },
];

export const articles = [
  {
    title: "Authentication in React Native using Firebase part 1",
    href: "https://medium.com/backticks-tildes/authentication-in-react-native-using-firebase-part-1-ed35294812e0",
    summary:
      "Introduces a React Native Firebase authentication flow by building the initial sign-in interface and component structure.",
    meta: "Medium / Oct 18, 2018 / 5 min read",
  },
  {
    title: "Authentication in React Native using Firebase part 2",
    href: "https://medium.com/backticks-tildes/authentication-in-react-native-using-firebase-part-2-70e570e7226e",
    summary:
      "Continues the tutorial by wiring the login flow to Firebase and moving the app from UI scaffolding to working authentication.",
    meta: "Medium / Oct 18, 2018 / 6 min read",
  },
];

export const aboutParagraphs = [
  "I am a senior full-stack and AI engineer from Nigeria. Over the last eight years, I have worked across product engineering, backend systems, platform infrastructure, and AI-powered workflows.",
  "My recent work has centered on turning AI from an idea into production systems: retrieval pipelines, agent workflows, voice-enabled applications, deployment automation, and the cloud infrastructure required to operate them reliably.",
  "I am most effective in environments where I can move from architecture and implementation through deployment, debugging, and iteration. I care about systems that are useful, measurable, and maintainable.",
  "Outside engineering, chess is one of the ways I reset and stay sharp. I enjoy the strategic side of the game for the same reason I enjoy systems design: clear tradeoffs, long-term planning, and disciplined execution.",
];

export const education = [
  "Post Graduate Certificate, Big Data Solution Architecture - Conestoga College",
  "B.Sc. Computer Science - Nnamdi Azikiwe University",
];
